export class ClusterType {
  Key: string;
  Value: string;
}
